import React, { FC } from 'react'
import Image from '../../../common/Image/Image'
import { STORIES_NO_COVER } from '../../../data'
import css from './Stories.module.scss'
import maxWidthCss from '../../../layout/MaxWidth/MaxWidth.module.scss'
import PerfectScrollbar from 'react-perfect-scrollbar'
import cx from 'classnames'
import { IStories } from '../../../types'

interface IStoriesProps {
  setStoryOpen: React.Dispatch<React.SetStateAction<string>>
  stories: IStories[]
}
const Stories: FC<IStoriesProps> = ({ setStoryOpen, stories }) => {
  if (!stories.length) {
    return null
  }

  return (
    <section
      className={cx(
        css.outer,
        stories.length < 4 && [
          maxWidthCss.maxWidth,
          maxWidthCss.limited,
          css.outerMaxWidth,
        ],
      )}
    >
      <PerfectScrollbar
        options={{ maxScrollbarLength: 200, useBothWheelAxes: true }}
      >
        <ul
          className={cx(css.wrapper, stories.length < 4 && css.wrapperMaxWidth)}
        >
          {stories.map((story) => {
            return (
              <li
                key={story.id}
                className={cx(css.item, stories.length < 4 && css.itemMaxWidth)}
                onClick={() => {
                  setStoryOpen(story.id)
                }}
              >
                <div className={css.image_wrapper}>
                  <figure className={css.image}>
                    {story.img ? (
                      <Image
                        src={story.img}
                        alt="stories"
                        layout="fill"
                        objectFit="cover"
                        width={153}
                      />
                    ) : (
                      <img
                        className={css.noImage}
                        src={STORIES_NO_COVER}
                        alt="stories"
                      />
                    )}
                  </figure>
                </div>

                <div className={css.title}>{story.title}</div>
              </li>
            )
          })}
        </ul>
      </PerfectScrollbar>
    </section>
  )
}

export default Stories
